import { useMessage } from '@hooks/useMessage'
import { useEffect, useState } from 'react'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import { MainStatDto } from '@dto/mainStat/mainStat.dto'
import { useCurrencySelector } from '@store/selectors/currency'

interface IProps {
  dates: string[] | 'all'
  crmId: string[] | 'all'
  isAllCrms?: boolean
}

interface IReturn extends MainStatDto {
  isLoading: boolean
}

export const useMainStatApi = ({ dates, crmId, isAllCrms }: IProps): IReturn => {
  const { error } = useMessage()
  const [result, setResult] = useState<MainStatDto>()
  const [isLoading, setIsLoading] = useState(false)
  const { btc } = useCurrencySelector()

  const getData = async () => {
    if (!dates || !crmId || !crmId?.length) return
    try {
      setIsLoading(true)
      const { data }: AxiosResponse<MainStatDto> = await axiosInstance.get(serverPath.MAIN_STAT, {
        params: {
          id: isAllCrms ? [] : crmId,
          dates: !dates?.length || dates === 'all' ? null : [dates[0], dates[1]],
          btc,
        },
      })
      setResult(data)
    } catch (e) {
      error(errorMapper(ErrorMessages.GET_DATA, e), ErrorMessages.SERVER_ERROR)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (crmId.length) {
      getData().then()
    }
  }, [dates, crmId, isAllCrms, btc])

  return { ...result, isLoading: isLoading ?? false }
}
